import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import HotelsNewForm from './HotelsNewForm';

const HotelsNew = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Hotel" title="New role" subParent="Hotels" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>New role</H5>
                <Link to="/hotels">
                  <Btn color="primary">Back to hotels</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <HotelsNewForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Create</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default HotelsNew;
